import { render, staticRenderFns } from "./carFlights.vue?vue&type=template&id=4b354e50&scoped=true&"
import script from "./carFlights.vue?vue&type=script&lang=js&"
export * from "./carFlights.vue?vue&type=script&lang=js&"
import style0 from "./carFlights.vue?vue&type=style&index=0&id=4b354e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b354e50",
  null
  
)

export default component.exports